export default __webpack_public_path__ + "static/09.logo_monochrome_black-bg-179010a8363f75e28213c85c016415f9.svg";